// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__lFQue"};